
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import CPCheckboxAccordion from '../open-account/input/CPCheckboxAccordion.vue';
import CPDueDiligenceSourceAccordianItem from './CPDueDiligenceSourceAccordianItem.vue';

@Component({
    components: {
        CPCheckboxAccordion,
        CPDueDiligenceSourceAccordianItem
    }
}) 
export default class CPDueDiligenceSourceDetails extends Vue { }
